var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideFixedIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87715 32.5278C1.6886 32.5278 1.4985 32.4913 1.31748 32.4163C0.770616 32.1899 0.414062 31.6562 0.414062 31.0644V7.65023C0.414062 3.61568 3.69636 0.333313 7.73098 0.333313H30.5598C34.5944 0.333313 37.8767 3.61568 37.8767 7.65023V19.3573C37.8767 23.3919 34.5944 26.6742 30.5598 26.6742H8.94325C8.55238 26.6742 8.18492 26.8265 7.90842 27.1028L2.9122 32.0991C2.63226 32.3791 2.25793 32.5278 1.87715 32.5278ZM7.73098 3.26008C5.31025 3.26008 3.34083 5.2295 3.34083 7.65023V27.5315L5.83897 25.0333C6.66827 24.2041 7.77071 23.7475 8.94325 23.7475H30.5598C32.9805 23.7475 34.9499 21.778 34.9499 19.3573V7.65023C34.9499 5.2295 32.9805 3.26008 30.5598 3.26008H7.73098Z",
    fill: "#BC9850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1446 17.894C17.9937 17.894 16.9059 17.4518 16.0816 16.6489L7.91886 8.69857C7.33995 8.13466 7.32773 7.20819 7.89164 6.6292C8.45556 6.05029 9.38203 6.038 9.96094 6.60191L18.1236 14.5523C18.3984 14.8198 18.7609 14.9671 19.1446 14.9671C19.5282 14.9671 19.8907 14.8198 20.1653 14.5523L28.3282 6.60184C28.9072 6.03792 29.8336 6.05014 30.3975 6.62913C30.9614 7.20812 30.9492 8.13459 30.3702 8.6985L22.2074 16.6489C21.3833 17.4518 20.2954 17.894 19.1446 17.894Z",
    fill: "#BC9850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideFixedIcon1);
export default __webpack_public_path__ + "static/media/side-fixed-icon1.6d234a0849cd1d52da2cad139f4feb43.svg";
export { ForwardRef as ReactComponent };